import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';

const TaxiNamur = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Taxi Namur - Chauffeur Privé Luxe | Service VIP 24/7</title>
        <meta name="description" content="Service de taxi privé de luxe à Namur. Chauffeur professionnel VIP, Mercedes & Lexus, disponible 24/7. Réservation en ligne." />
        <meta name="keywords" content="taxi namur, chauffeur privé namur, vtc namur, transfert namur" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-namur" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Taxi Namur - Chauffeur Privé
          </h1>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Namur" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Service de Taxi Privé à Namur</h2>
          <p className="text-gray-300">
            <strong>Taxi Namur</strong> - Transport VIP avec chauffeur privé. Trajets vers Bruxelles, 
            Charleroi, Luxembourg. Service 24/7.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TaxiNamur;